import StartupsInstance from 'modules/startups/repository';
import { formatErrors } from 'utils/functions';

export function deleteStartup(id) {
  return StartupsInstance.startupDelete(id)
    .catch((error) => { throw formatErrors(error); });
}
